module.exports = __webpack_public_path__ + "img/leftdd.cc557a14.png";